module.exports = __webpack_public_path__ + "static/media/filter-icon-rotate.3f80724a.svg";